import { call, select } from 'redux-saga/effects';
import {
  PapiCheckout,
  PapiDacheckoutPurchase,
  PapiRequestDacheckoutPurchase,
} from '@wix/da-papi-types';
import { requestNapi } from '@wix/da-http-client/pkg/request';
import {
  getExtraNote,
  getGiftIsAnon,
  getCheckout,
} from '../selectors/checkout';
import { API_BASE_PATH } from '../../constants';
import { PaymentMethod } from '../types';

export function* placeOrder(paymentMethod: PaymentMethod) {
  const checkout: PapiCheckout = yield select(getCheckout);
  const note = yield select(getExtraNote);
  const giftIsAnon = yield select(getGiftIsAnon);
  const data: PapiRequestDacheckoutPurchase = {
    subproductid: checkout.order.subproductId,
    single_use_token: checkout.singleUseToken as any,
    foruserid: checkout.giftUser?.userId as any,
    note,
    gift_type: giftIsAnon ? 'anonymous' : 'public',
    payment_info: { payment_method: paymentMethod },
  };
  const response: PapiDacheckoutPurchase = yield call(requestNapi, {
    method: 'post',
    baseURL: API_BASE_PATH,
    url: 'purchase',
    data,
  });
  return response;
}
